import ModalComponent from "@/common/Modal";
import { SotEnableModalProps } from "../types";
import { Box, Button, Text, Switch, Divider } from "@chakra-ui/react";
import React, { useState, useEffect } from 'react'
import './OptInForm.scss';
import { getDealerActionsToBeSaved, getIsCreateDealerActionCompleted, getIsCreateDealerActionInprogress } from '@/explore/ducks/selectors';
import { setDealerActionsToBeSaved, setIsCreateDealerActionInprogress, callToCreateDealerAction } from '@/explore/ducks/slice';
import { DealerProfileType } from '@masterffl/dealer-profile-component';
import { useDispatch } from "react-redux";

export function OptInForm({ data }: { data: DealerProfileType }) {
  const dispatch = useDispatch();
  const [isSOTExist, setIsSOTExist] = useState(false)

  const updateSotEnable = (isEnable: boolean) => {
    if(isEnable){
      dispatch(setDealerActionsToBeSaved([{
        name: 'sot_enable',
        type: 'create',
        license_key: data?.primaryInboundDetails?.licenseKey || '',
        dealer_id: data?._id,
      }]));
    } else {
      dispatch(setDealerActionsToBeSaved([{
        name: 'sot_enable',
        type: 'delete',
        license_key: data?.sot?.licenseKey || data?.primaryInboundDetails?.licenseKey || '',
        dealer_id: data?._id,
      }]));
    }
  }

  useEffect(() => {
    setIsSOTExist(!!data?.sot?.isSOTDealer);
  },[data])
  return (
    <Box>
      <Box className="update_preferences_text">
        <Text className="update_preferences_title">Update this dealer’s SOT status.</Text>
      </Box>
      <Box className="toggle_section_wrapper">
         <Box className="toggle_section">
          <Text><Text as='b'>
              {isSOTExist ? 'Enable' : 'Disable'}</Text> SOT for this dealer</Text>
          <Switch
            color={'red'} 
            size='lg' 
            onChange={() => setIsSOTExist(prev => {
              updateSotEnable(!prev);
              return !prev;
            })}
            isChecked={isSOTExist}
            sx={{
              '& .chakra-switch__track': { bg: 'red.100' }, // Track color when unchecked
              '& .chakra-switch__thumb': { bg: 'red.600', border: '2px', borderColor: 'red.100' }, // Thumb color when unchecked
              '.chakra-switch__track[data-checked]:not([data-theme])': { backgroundColor: 'green.100', },
              '.chakra-switch__thumb[data-checked]:not([data-theme])': { backgroundColor: 'green.400', border: '2px', borderColor: 'green.100' },
            }}
          />
        </Box>
      </Box>
      <Divider style={{ width: '90%', margin: 'auto' }} />
    </Box>
  );
}

export default function SotEnableModal({
  isOpen,
  onClose,
  data
}: SotEnableModalProps) {
  const dispatch = useDispatch()
  const dealerActionsToBeSaved = getDealerActionsToBeSaved();
  const isCreateDealerActionInprogress = getIsCreateDealerActionInprogress();
  const isCreateDealerActionCompleted = getIsCreateDealerActionCompleted()

  const onSaveHandler = async () => {
    dispatch(setIsCreateDealerActionInprogress(true))
    dispatch(callToCreateDealerAction({ actionList: dealerActionsToBeSaved }));
  };

  useEffect(() => {
    if (!isCreateDealerActionInprogress && isCreateDealerActionCompleted) {
      onClose()
    }
  }, [isCreateDealerActionCompleted, isCreateDealerActionInprogress])

  return (
    <ModalComponent
      title="SOT"
      isOpen={isOpen}
      onClose={onClose}
      variant={2}
      className="btns"
      footer={
        <Box className="opt-in-footer">
          <Button
            className="cancel_btn"
            onClick={() => {
              onClose();
            }}
            isDisabled={isCreateDealerActionInprogress}
          >
            Cancel
          </Button>
          <Button
            className="save_btn"
            colorScheme="blue"
            background="#0C1E46"
            padding="8px 20px"
            onClick={onSaveHandler}
            isLoading={isCreateDealerActionInprogress}
            isDisabled={!dealerActionsToBeSaved?.length}
          >
            Save
          </Button>
        </Box>
      }
    >
      <OptInForm data={data} />
    </ModalComponent>
  )
}
